import { render, staticRenderFns } from "./BottomSheetAcceptNotifications.vue?vue&type=template&id=48b84944&scoped=true&"
import script from "./BottomSheetAcceptNotifications.vue?vue&type=script&lang=js&"
export * from "./BottomSheetAcceptNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetAcceptNotifications.vue?vue&type=style&index=0&id=48b84944&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b84944",
  null
  
)

component.options.__file = "BottomSheetAcceptNotifications.vue"
export default component.exports